module.exports = __webpack_public_path__ + "static/media/fight.25a109ef.wav";